export const projects = [
    {
    title: "Entroplot",
    subtitle: "Rust",
    description:
      "A Rust-based command-line tool for analyzing and visualizing file entropy. You can use it to find the entropy or randomness of a file. This is useful to determine if a file in encrypted or encoded.",
    image: "./entroplot.png",
    link: "https://github.com/Piyush-Bhor/entroplot",
  },
  {
    title: "OSX Chrome Infostealer",
    subtitle: "Golang, macOS Internals, Exploit Development",
    description:
      "OSX Chrome Infostealer is a tool for decrypting and exporting Chrome passwords and sending them securely to a remote Command and Control (C2) Server.",
    image: "./osx_infostealer.png",
    link: "https://github.com/Piyush-Bhor/osx-chrome-infostealer",
  },
  {
    title: "Polymorphic Malware",
    subtitle: "Malware Research, Self-modifying code",
    description:
      "A proof of concept (POC) malware that updates its source code everytime it replicates. The process allows it to evade signature based anti-virus engines.",
    image: "./Polymorphic_Malware.png",
    link: "https://github.com/Piyush-Bhor/polymorphic-malware",
  },
  {
    title: "Panic Ransomware",
    subtitle: "Cryptography, Anti-VM Techniques",
    description:
      "A ransomware project developed for research purposes at Nullzec. The malware demonstrates common techniques used in ransomware attacks, including hybrid cryptography, anti-VM techniques, etc.",
    image: "./Panic_Ransomware.png",
    link: "https://github.com/Piyush-Bhor/Panic-Ransomware",
  },
  {
    title: "Sentinel-2 Wildfire Data Pipeline",
    subtitle: "Python, Remote Sensing, Geospatial ML",
    description:
  "A collection of Jupyter notebooks and scripts to build a British Columbia wildfire dataset using paired RGB and SWIR Sentinel-2 imagery for wildfire detection and classification.",
    image: "./sentinel2.png",
    link: "https://github.com/Piyush-Bhor/British-Columbia-Wildfire-Sentinel-2-Dataset-EO",
  },
  {
    title: "The Cannabis API",
    subtitle: "EJS, MongoDB, Express, Node, Vercel",
    description:
      "The Cannabis API is a RESTful API that provides a bunch of information about various cannabis strains. It allows you to query and retrieve details such as strain name, type, rating, effects, flavors, and descriptions.",
    image: "./the_cannabis_api.png",
    link: "https://github.com/Piyush-Bhor/The_Cannabis_API",
  },
];

export const research = [
  {
    title: "CVE-2024-11392",
    subtitle: "Hugging Face Transformers MobileViTV2",
    description:
      "Hugging Face Transformers MobileViTV2 Deserialization of Untrusted Data Remote Code Execution Vulnerability. This vulnerability allows remote attackers to execute arbitrary code on affected installations of Hugging Face Transformers.",
    image: "./CVE-2024-11392.png",
    link: "https://nvd.nist.gov/vuln/detail/CVE-2024-11392",
  },
  {
    title: "CVE-2024-11393",
    subtitle: "Hugging Face Transformers MaskFormer",
    description:
      "Hugging Face Transformers MaskFormer Model Deserialization of Untrusted Data Remote Code Execution Vulnerability. This vulnerability allows remote attackers to execute arbitrary code on affected installations of Hugging Face Transformers.",
    image: "./CVE-2024-11393.png",
    link: "https://nvd.nist.gov/vuln/detail/CVE-2024-11393",
  },
  {
    title: "CVE-2024-11394",
    subtitle: "Hugging Face Transformers Trax",
    description:
      "Hugging Face Transformers Trax Model Deserialization of Untrusted Data Remote Code Execution Vulnerability. This vulnerability allows remote attackers to execute arbitrary code on affected installations of Hugging Face Transformers.",
    image: "./CVE-2024-11394.png",
    link: "https://nvd.nist.gov/vuln/detail/CVE-2024-11394",
  },
  {
    title: "ZDI-CAN-25423",
    subtitle: "Hugging Face Transformers Perceiver",
    description:
      "Hugging Face Transformers Perceiver Model Deserialization of Untrusted Data Remote Code Execution Vulnerability. This vulnerability allows remote attackers to execute arbitrary code on affected installations of Hugging Face Transformers.",
    image: "./ZDI-CAN-25423.png",
    link: "https://www.zerodayinitiative.com/advisories/upcoming/",
  },
  {
    title: "ZDI-CAN-25424",
    subtitle: "Hugging Face Transformers Transfo-XL",
    description:
      "Hugging Face Transformers Transfo-XL Model Deserialization of Untrusted Data Remote Code Execution Vulnerability. This vulnerability allows remote attackers to execute arbitrary code on affected installations of Hugging Face Transformers.",
    image: "./ZDI-CAN-25424.png",
    link: "https://www.zerodayinitiative.com/advisories/upcoming/",
  },
  
];

export const conferences = [
  {
    title: "TAICO",
    subtitle: "Toronto AI and Cybersecurity Organization",
    description:
      "Exploiting ML libraries for Fun and Profit. I talked about unpatched vulnerabilities in popular ML libraires and how they can exploited to get a reverse shell.",
    image: "./taico.jpg",
    link: "https://taico.ca/posts/taico-jan-2025-meetup/",
  },
  {
    title: "AI Friends",
    subtitle: "AI Friends Meetup Toronto",
    description:
      "Developing Exploits for CVE-2024-11393. I showcased how to create a .pkl backdoor and use it to exploit deserialization vulnerabilities, using CVE-2024-11393 as an example.",
    image: "./AI_Friends.png",
    link: "#",
  },
];

export const skills = [
  "RE: IDA Pro, Ghidra, GDB",
  "Python, TS, Rust, C/C++",
  "Django, FastAPI, Express, NextJS",
  "PostgreSQL, MongoDB, Redis",
  "API Development (REST, GraphQL)",
  "AWS, Docker, Kubernetes, Linux Administration",
];



// WEBPACK FOOTER //
// ./src/data.js